import { render, staticRenderFns } from "./FirebaseMessaging.vue?vue&type=template&id=5e3e1f77&scoped=true&"
import script from "./FirebaseMessaging.vue?vue&type=script&lang=ts&"
export * from "./FirebaseMessaging.vue?vue&type=script&lang=ts&"
import style0 from "./FirebaseMessaging.vue?vue&type=style&index=0&id=5e3e1f77&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e3e1f77",
  null
  
)

export default component.exports